import { Reducer } from "redux";
import { ActionTypes } from './action-types';
import * as Actions from "./actions";

export interface IShortcutsState {
    error: boolean;
    isLoading: boolean;
    items: Spintr.IShortcut[];
    hasFetched: boolean;
}

const initialState: IShortcutsState = {
    error: false,
    isLoading: false,
    items: [],
    hasFetched: false
};

const shortcutsReducer: Reducer<IShortcutsState, Actions.ShortcutAction> = (state = initialState, action) =>  {
    switch (action.type) {
        case ActionTypes.FetchUserShortcutsPending:
            return {
                ...state,
                error: false,
                isLoading: true,
            };

        case ActionTypes.FetchUserShortcutsRejected:
            return {
                ...state,
                error: true,
                isLoading: false,
            };

        case ActionTypes.FetchUserShortcutsFulfilled:
            return {
                ...state,
                error: false,
                isLoading: false,
                hasFetched: true,
                items: action.payload.data,
            };

        default:
            return state;
    }
};

export default shortcutsReducer;
